import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {AltIntro} from "../components/hackathon/AltIntro";
import {Testimonials} from "../components/hackathon/Testimonials";
import {Community} from "../components/hackathon/Community";
import {Events} from "../components/hackathon/Events";
import {DevSubscribe} from "../components/global/DevSubscribe";
import MarqueeComponent from "../components/hackathon/MarqueeComponent";
import { Accordian } from "../components/hackathon/Accordian";




const Hackathon = () => {
  return (
    <Layout>
        <AltIntro />
        <Events />
        <Accordian />
        <MarqueeComponent />
        <Testimonials />
        <Community /> 
        <DevSubscribe />
    </Layout>
  )
};

export default Hackathon;

export const Head = () => <Seo title="Rootstock Hacker Hub"/>;